import { ReservationBillFragment, ReservationDetailFragment } from 'src/api/api.generated'
import { AssignedProductionF, BillF } from '../types/reservation-detail.types'

export const AUTO = 'auto-generated-row-billId'
export const DUMMY = 'DUMMY'

export function getBillsF(reservation: ReservationDetailFragment | null | undefined, bills: ReservationBillFragment[] | null | undefined): BillF[] | null | undefined {
  if (reservation === null) {
    return null
  }
  if (reservation === undefined) {
    return undefined
  }
  if (bills === null) {
    return null
  }
  if (bills === undefined) {
    return undefined
  }

  return bills
  // return bills.filter((b) => b.productions && b.productions.length > 0)
}

const dummyProductionAssigned: AssignedProductionF = {
  id: DUMMY,
  billId: 'XXX',
  quota: 1,
  production: {
    id: DUMMY,
    amount: 0,
    chargeCategory: { id: DUMMY, name: '-', cityTax: false, stayIncluded: false },
    currency: 'EUR',
    date: new Date(),
    quantity: 0,
    total: 0,
    vat: { code: '-', value: 0, id: '' },
  },
}

export function reduceAssignedProductions(bills: BillF[]): AssignedProductionF[] {
  return bills.reduce((previousValue: AssignedProductionF[], currentValue) => {
    const parsedAssignedProductions =
      currentValue.productions?.map((p) => {
        return {
          ...p,
          /** Set as paid if production belong to closed bill */
          paid: !currentValue.open,
        }
      }) || []
    if (parsedAssignedProductions.length <= 0) {
      return [...previousValue, { ...dummyProductionAssigned, id: `${DUMMY}/${currentValue.id}`, billId: currentValue.id }]
    } else {
      return [...previousValue, ...parsedAssignedProductions]
    }
  }, [])
}
